export const partner = 'afcpe';

export const microSites = ['mme1'];
export function sideEffects() {}

export const tiers = {
	isMicro: /mme/
};

export const flags = ({ isMicro }: Record<string, boolean>) => [
	['ati-use-single-rpc', true],
	['no-explore-assess', isMicro],
	['posttest', true],
	['practice-exam', true],
	['quiz-progress-chart', !isMicro],
	['use-alternate-footer', isMicro],
	['use-alternate-header', isMicro],
	['use-alternate-next', true],
	['use-alternate-pass-view', true],
	['use-assessment-chooser', !isMicro],
	['use-audio-topics', true],
	['use-carousel-view', !isMicro],
	['use-cutscores', false],
	['use-landing-page', !isMicro],
	['use-micro-view', isMicro],
	['use-png-badge-logo', isMicro],
	['use-search-in-heading', true],
	['use-study-plan', !isMicro],
	['use-svg-card-header-images', isMicro],
	['use-svg-header-image', isMicro],
	['use-toc', !isMicro],
	['use-topicgroup-quiz', false],
	['use-topicgroup-reading', true],
	['use-wylo', !isMicro],
	['use-xapi', true]
];
